//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { localeStore } from '@/store/locale'

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios'

export class BffClientBase {
  
  constructor() {
  }

  protected transformOptions(options: AxiosRequestConfig) {
    options.headers['Accept-Language'] = localeStore().locale
    return Promise.resolve(options)
  }

  protected transformResult(url: string, response: AxiosResponse<any>, processor: (response: AxiosResponse<any>) => any) {
    const contentType = response.headers['content-type'] as string
    if (contentType && contentType.indexOf('text/html') >= 0) {
      const loc = `${location.protocol}//${location.hostname}:${location.port}`
      if (response.request.responseURL.indexOf(loc) < 0) {
        const unauthorizedError = {
          status: 401,
          statusText: response.request.responseURL,
        }
        throw unauthorizedError
      }
    }
    return processor(response)
  }
}

export interface IOndernemingClient {
  /**
   * @return OK
   */
  geefDeelnemingen_GeefDeelnemingen(request: GeefDeelnemingenRequest): Promise<GeefDeelnemingenResponse>
  /**
   * @return OK
   */
  geefOnderneming_GeefOnderneming(request: GeefOndernemingRequest): Promise<GeefOndernemingResponse>
  /**
   * @return OK
   */
  geefPCenTW_GeefPCenTW(request: GeefPCenTWRequest): Promise<GeefPCenTWResponse>
  buildInfo_Index(): Promise<FileResponse>
}

export class OndernemingClient extends BffClientBase implements IOndernemingClient {
  private instance: AxiosInstance
  private baseUrl: string
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined

  constructor(baseUrl?: string, instance?: AxiosInstance) {
    super()

    this.instance = instance ? instance : axios.create()

    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : 'https://localhost:48883'
  }

  /**
   * @return OK
   */
  geefDeelnemingen_GeefDeelnemingen(request: GeefDeelnemingenRequest, cancelToken?: CancelToken | undefined): Promise<GeefDeelnemingenResponse> {
    let url_ = this.baseUrl + '/api/v1/geefdeelnemingen'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(request)

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.instance.request(transformedOptions_)
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeefDeelnemingen_GeefDeelnemingen(_response))
      })
  }

  protected processGeefDeelnemingen_GeefDeelnemingen(response: AxiosResponse): Promise<GeefDeelnemingenResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200
      return Promise.resolve<GeefDeelnemingenResponse>(result200)
    } else if (status === 400) {
      const _responseText = response.data
      let result400: any = null
      let resultData400 = _responseText
      result400 = resultData400
      return throwException('Validation errors.', status, _responseText, _headers, result400)
    } else if (status === 404) {
      const _responseText = response.data
      let result404: any = null
      let resultData404 = _responseText
      result404 = resultData404
      return throwException('Not found.', status, _responseText, _headers, result404)
    } else if (status === 401) {
      const _responseText = response.data
      let result401: any = null
      let resultData401 = _responseText
      result401 = resultData401
      return throwException('Not authorized to perform the operation.', status, _responseText, _headers, result401)
    } else if (status === 500) {
      const _responseText = response.data
      let result500: any = null
      let resultData500 = _responseText
      result500 = resultData500
      return throwException('Unexpected error.', status, _responseText, _headers, result500)
    } else if (status === 502) {
      const _responseText = response.data
      let result502: any = null
      let resultData502 = _responseText
      result502 = resultData502
      return throwException('Bad gateway error.', status, _responseText, _headers, result502)
    } else if (status === 403) {
      const _responseText = response.data
      let result403: any = null
      let resultData403 = _responseText
      result403 = resultData403
      return throwException('Insufficient permissions to perform the operation.', status, _responseText, _headers, result403)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException('An unexpected server error occurred.', status, _responseText, _headers)
    }
    return Promise.resolve<GeefDeelnemingenResponse>(null as any)
  }

  /**
   * @return OK
   */
  geefOnderneming_GeefOnderneming(request: GeefOndernemingRequest, cancelToken?: CancelToken | undefined): Promise<GeefOndernemingResponse> {
    let url_ = this.baseUrl + '/api/v1/geefonderneming'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(request)

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.instance.request(transformedOptions_)
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeefOnderneming_GeefOnderneming(_response))
      })
  }

  protected processGeefOnderneming_GeefOnderneming(response: AxiosResponse): Promise<GeefOndernemingResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200
      return Promise.resolve<GeefOndernemingResponse>(result200)
    } else if (status === 400) {
      const _responseText = response.data
      let result400: any = null
      let resultData400 = _responseText
      result400 = resultData400
      return throwException('Validation errors.', status, _responseText, _headers, result400)
    } else if (status === 404) {
      const _responseText = response.data
      let result404: any = null
      let resultData404 = _responseText
      result404 = resultData404
      return throwException('Not found.', status, _responseText, _headers, result404)
    } else if (status === 401) {
      const _responseText = response.data
      let result401: any = null
      let resultData401 = _responseText
      result401 = resultData401
      return throwException('Not authorized to perform the operation.', status, _responseText, _headers, result401)
    } else if (status === 500) {
      const _responseText = response.data
      let result500: any = null
      let resultData500 = _responseText
      result500 = resultData500
      return throwException('Unexpected error.', status, _responseText, _headers, result500)
    } else if (status === 502) {
      const _responseText = response.data
      let result502: any = null
      let resultData502 = _responseText
      result502 = resultData502
      return throwException('Bad gateway error.', status, _responseText, _headers, result502)
    } else if (status === 403) {
      const _responseText = response.data
      let result403: any = null
      let resultData403 = _responseText
      result403 = resultData403
      return throwException('Insufficient permissions to perform the operation.', status, _responseText, _headers, result403)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException('An unexpected server error occurred.', status, _responseText, _headers)
    }
    return Promise.resolve<GeefOndernemingResponse>(null as any)
  }

  /**
   * @return OK
   */
  geefPCenTW_GeefPCenTW(request: GeefPCenTWRequest, cancelToken?: CancelToken | undefined): Promise<GeefPCenTWResponse> {
    let url_ = this.baseUrl + '/api/v1/geefpcentw'
    url_ = url_.replace(/[?&]$/, '')

    const content_ = JSON.stringify(request)

    let options_: AxiosRequestConfig = {
      data: content_,
      method: 'POST',
      url: url_,
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      cancelToken,
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.instance.request(transformedOptions_)
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeefPCenTW_GeefPCenTW(_response))
      })
  }

  protected processGeefPCenTW_GeefPCenTW(response: AxiosResponse): Promise<GeefPCenTWResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200) {
      const _responseText = response.data
      let result200: any = null
      let resultData200 = _responseText
      result200 = resultData200
      return Promise.resolve<GeefPCenTWResponse>(result200)
    } else if (status === 400) {
      const _responseText = response.data
      let result400: any = null
      let resultData400 = _responseText
      result400 = resultData400
      return throwException('Validation errors.', status, _responseText, _headers, result400)
    } else if (status === 404) {
      const _responseText = response.data
      let result404: any = null
      let resultData404 = _responseText
      result404 = resultData404
      return throwException('Not found.', status, _responseText, _headers, result404)
    } else if (status === 401) {
      const _responseText = response.data
      let result401: any = null
      let resultData401 = _responseText
      result401 = resultData401
      return throwException('Not authorized to perform the operation.', status, _responseText, _headers, result401)
    } else if (status === 500) {
      const _responseText = response.data
      let result500: any = null
      let resultData500 = _responseText
      result500 = resultData500
      return throwException('Unexpected error.', status, _responseText, _headers, result500)
    } else if (status === 502) {
      const _responseText = response.data
      let result502: any = null
      let resultData502 = _responseText
      result502 = resultData502
      return throwException('Bad gateway error.', status, _responseText, _headers, result502)
    } else if (status === 403) {
      const _responseText = response.data
      let result403: any = null
      let resultData403 = _responseText
      result403 = resultData403
      return throwException('Insufficient permissions to perform the operation.', status, _responseText, _headers, result403)
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException('An unexpected server error occurred.', status, _responseText, _headers)
    }
    return Promise.resolve<GeefPCenTWResponse>(null as any)
  }

  buildInfo_Index(cancelToken?: CancelToken | undefined): Promise<FileResponse> {
    let url_ = this.baseUrl + '/buildinfo'
    url_ = url_.replace(/[?&]$/, '')

    let options_: AxiosRequestConfig = {
      responseType: 'blob',
      method: 'GET',
      url: url_,
      headers: {
        Accept: 'application/octet-stream',
      },
      cancelToken,
    }

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.instance.request(transformedOptions_)
      })
      .catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
          return _error.response
        } else {
          throw _error
        }
      })
      .then((_response: AxiosResponse) => {
        return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processBuildInfo_Index(_response))
      })
  }

  protected processBuildInfo_Index(response: AxiosResponse): Promise<FileResponse> {
    const status = response.status
    let _headers: any = {}
    if (response.headers && typeof response.headers === 'object') {
      for (let k in response.headers) {
        if (response.headers.hasOwnProperty(k)) {
          _headers[k] = response.headers[k]
        }
      }
    }
    if (status === 200 || status === 206) {
      const contentDisposition = response.headers ? response.headers['content-disposition'] : undefined
      const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined
      const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined
      return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers })
    } else if (status !== 200 && status !== 204) {
      const _responseText = response.data
      return throwException('An unexpected server error occurred.', status, _responseText, _headers)
    }
    return Promise.resolve<FileResponse>(null as any)
  }
}

export interface GeefDeelnemingenResponse {
  deelnemingen?: GeefDeelnemingDto[] | undefined
  waarschuwingen?: MagdaError[] | undefined
}

export interface GeefDeelnemingDto {
  deelnemer?: DeelnemerDto
  deelnemingIn?: DeelnemingInDto
  soort?: string
  neergelegd?: DeelnemingNeergelegdDto
}

export interface DeelnemerDto {
  ondernemingsnummer?: string
  jaarrekening?: DeelnemerJaarrekeningDto
}

export interface DeelnemerJaarrekeningDto {
  referentienummer?: string
  datumAfsluiting?: string
}

export interface DeelnemingInDto {
  ondernemingsnummer?: string
  naam?: string
  adres?: AdresOndernemingDeelnemingInDto
  jaarrekening?: DeelnemingInJaarrekeningDto
}

export interface AdresOndernemingDeelnemingInDto {
  straat?: string
  huisnummer?: string
  busnummer?: string
  gemeente?: GemeenteDto
  staat?: string
  land?: LandDto
}

export interface GemeenteDto {
  naam?: string
  nisCode?: string
  postCode?: string
}

export interface LandDto {
  naam?: string
  nisCode?: string
  isoCode?: string
}

export interface DeelnemingInJaarrekeningDto {
  munt?: string
  eigenVermogen?: string
  nettoresultaat?: string
  datumAfsluiting?: string
}

export interface DeelnemingNeergelegdDto {
  rechtstreeks?: RechtstreeksNeergelegdDto
  doorDochteronderneming?: DoorDochterondernemingNeergelegdDto
}

export interface RechtstreeksNeergelegdDto {
  aantal?: string
  percentage?: string
}

export interface DoorDochterondernemingNeergelegdDto {
  percentage?: string
}

export interface MagdaError {
  message: string | undefined
  description?: string | undefined
  externalCode?: string | undefined
  type?: MagdaErrorType
}

export enum MagdaErrorType {
  Error = 'Error',
  Warning = 'Warning',
  Information = 'Information',
}

export interface ErrorMessage {
  type?: string | undefined
  title: string
  status?: number
  detail: string
  instance?: string | undefined
}

export interface GeefDeelnemingenRequest {
  ondernemingsNummer?: DeelnemingsOndernemingsnummerTypeDto
  from?: Date
  until?: Date
}

export interface DeelnemingsOndernemingsnummerTypeDto {
  value?: string
  type?: DeelnemingsOndernemingsnummerTypeEnum
}

export enum DeelnemingsOndernemingsnummerTypeEnum {
  Deelnemer = 'Deelnemer',
  DeelnemingIn = 'DeelnemingIn',
}

export interface GeefOndernemingResponse {
  onderneming?: GeefOndernemingDto | undefined
  waarschuwingen?: MagdaError[] | undefined
}

export interface GeefOndernemingDto {
  ondernemingsnummer?: string
  authentiekBron?: CodeOmschrijvingDto
  ondernemingOfVestiging?: string
  rechtstoestanden?: RechtstoestandDto[]
  vestigingen?: VestigingDto[]
  bankrekeningen?: BankrekeningDto[]
  functies?: FunctieDto[]
  activiteiten?: ActiviteitDto[]
  gerelateerdeOndernemingen?: GerelateerdeOndernemingDto[]
  hoedanigheden?: HoedanigheidDto[]
  externeIdentificaties?: ExterneIdentificatieDto[]
  bijhuis?: BijhuisDto
  doorhalingen?: DoorhalingDto[]
  statusKBO?: CodeOmschrijvingDto
  soortOnderneming?: CodeOmschrijvingDto
  maatschappelijkeZetel?: MaatschappelijkeZetelDto
  namen?: NamenOndernemingDto
  adressen?: AdresOndernemingDto[]
  datumStart?: string
  datumInschrijving?: string
  duurtijd?: string
  datumAfsluiting?: string
  stopzetting?: CodeOmschrijvingExtentieDto
  rechtsvormen?: RechtsvormDto[]
}

export interface CodeOmschrijvingDto {
  code?: string
  omschrijving?: string
}

export interface RechtstoestandDto {
  code?: string
  omschrijving?: string
  instrumenterendeOverheid?: string
  datumBegin?: string
  datumEinde?: string
}

export interface VestigingDto {
  vestigingsnummer?: string
  statusKBO?: CodeOmschrijvingDto
  maatschappelijkeZetel?: MaatschappelijkeZetelDto
  namen?: NamenOndernemingDto
  adressen?: AdresOndernemingDto[]
  datumAfsluiting?: string
  stopzetting?: CodeOmschrijvingExtentieDto
  datumBegin?: string
  datumEinde?: string
}

export interface MaatschappelijkeZetelDto {
  relatie?: CodeOmschrijvingDto
  ondernemingsnummer?: string
  stopzetting?: CodeOmschrijvingDto
  datumBegin?: string
  datumEinde?: string
}

export interface NamenOndernemingDto {
  maatschappelijkeNamen?: NaamOndernemingDto[]
  afgekorteNamen?: NaamOndernemingDto[]
  commercieleNamen?: NaamOndernemingDto[]
}

export interface NaamOndernemingDto {
  naam?: string
  datumBegin?: string
  datumEinde?: string
  taalcode?: string
}

export interface AdresOndernemingDto {
  land?: LandDto
  straat?: string
  huisnummer?: string
  busnummer?: string
  gemeente?: GemeenteDto
  staat?: string
  type?: CodeOmschrijvingDto
  descripties?: DescriptieDto[]
  doorhalingen?: DoorhalingDto[]
  datumBegin?: string
  datumEinde?: string
}

export interface DescriptieDto {
  adres?: AdresOndernemingBasisDto
  taal?: string
  aanvulling?: string
  contact?: ContactDto
}

export interface AdresOndernemingBasisDto {
  land?: LandDto
  straat?: string
  huisnummer?: string
  busnummer?: string
  gemeente?: GemeenteDto
  staat?: string
}

export interface ContactDto {
  telefoonnummer?: string
  faxnummer?: string
  gsm?: string
  email?: string
  website?: string
}

export interface DoorhalingDto {
  reden?: CodeOmschrijvingDto
  datumBegin?: string
  datumEinde?: string
}

export interface CodeOmschrijvingExtentieDto {
  code?: string
  omschrijving?: string
  datum?: string
}

export interface BankrekeningDto {
  rekeningnummer?: string
  doel?: string
  iban?: string
  bic?: string
  nietSEPAnummer?: string
  datumBegin?: string
  datumEinde?: string
}

export interface FunctieDto {
  functieHouderVan?: string
  aanduidingPersoonOnderneming?: CodeOmschrijvingDto
  vrijstelling?: VrijstellingDto
  eindeFunctie?: CodeOmschrijvingDto
  aardFunctie?: CodeOmschrijvingDto
  persoon?: FunctiePersoonDto
  onderneming?: FunctieOndernemingDto
  datumBegin?: string
  datumEinde?: string
}

export interface VrijstellingDto {
  code?: string
  omschrijving?: string
  aanduidingVrijstelling?: boolean
  geenKMO?: boolean
}

export interface FunctiePersoonDto {
  insz?: string
  achterNaam?: string
  voorNaam?: string
  straat?: string
}

export interface FunctieOndernemingDto {
  ondernemingsnummer?: string
  naam?: NaamOndernemingDto
}

export interface ActiviteitDto {
  nace?: NaceDto
  type?: CodeOmschrijvingDto
  groep?: string
  datumBegin?: string
  datumEinde?: string
}

export interface NaceDto {
  code?: string
  omschrijving?: string
  versie?: string
}

export interface GerelateerdeOndernemingDto {
  relatie?: RelatieDto
  ondernemingsnummer?: string
  eindeRelatie?: CodeOmschrijvingDto
  datumBegin?: string
  datumEinde?: string
}

export interface RelatieDto {
  code?: string
  omschrijving?: string
  isDochter?: boolean
}

export interface HoedanigheidDto {
  code?: string
  omschrijving?: string
  datumInschrijving?: string
  instrumenterendeAdministratie?: string
  duurtijd?: string
  fase?: CodeOmschrijvingDto
  beeindiging?: CodeOmschrijvingDto
  datumBegin?: string
  datumEinde?: string
}

export interface ExterneIdentificatieDto {
  edrl?: string
  naam?: string
}

export interface BijhuisDto {
  adres?: AdresOndernemingDto
  stopzetting?: CodeOmschrijvingExtentieDto
  datumBegin?: string
  datumEinde?: string
}

export interface RechtsvormDto {
  code?: string
  omschrijving?: string
  afkorting?: string
  datumBegin?: string
  datumEinde?: string
}

export interface GeefOndernemingRequest {
  ondernemingsNummer?: string
}

export interface GeefPCenTWResponse {
  pCenTWen?: PCenTWDto[] | undefined
  waarschuwingen?: MagdaError[] | undefined
}

export interface PCenTWDto {
  ondernemingsNummer?: string
  authentiekeBron?: CodeOmschrijvingDto
  paritairComite?: CodeOmschrijvingDto
  periodeKwartaal?: PeriodeKwartaalDto
  tewerkstelling?: CodeOmschrijvingDto
}

export interface PeriodeKwartaalDto {
  jaar?: string
  kwartaal?: string
  begin?: string
  einde?: string
}

export interface GeefPCenTWRequest {
  ondernemingsNummer?: string
}

export interface FileResponse {
  data: Blob
  status: number
  fileName?: string
  headers?: { [name: string]: any }
}

export class ApiException extends Error {
  message: string
  status: number
  response: string
  headers: { [key: string]: any }
  result: any

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super()

    this.message = message
    this.status = status
    this.response = response
    this.headers = headers
    this.result = result
  }

  protected isApiException = true

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true
  }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any }, result?: any): any {
  throw new ApiException(message, status, response, headers, result)
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
  return obj && obj.isAxiosError === true
}
